export enum Portals {
    CONNECT_WALLET = 'connect-wallet-modal',
    SWITCH_NETWORK = 'switch-network',
    NOTIFICATION = 'notification-modal',
}
